export default (flag) => ({
  name: "FlagTemplateCheckingAnalysis",

  data: function () {
    return {
      flag,
    };
  },

  render: function (h) {
    return h("div", [
      "Student response doesn't match the submission template.",
    ]);
  },
});
